"use client";

import { motion } from "framer-motion";

interface PendingIconProps {
  size?: number;
  strokeWidth?: number;
  className?: string;
}

const fadeIn = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      delay: 0.3,
      duration: 0.5,
      ease: [0.25, 0.1, 0.25, 1],
    },
  },
};

export function PendingIcon({
  size = 80,
  strokeWidth = 2,
  className = "",
}: PendingIconProps) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      initial="hidden"
      animate="visible"
      className={className}
    >
      <title>Pending Status</title>
      {/* Background circle */}
      <motion.circle
        cx="50"
        cy="50"
        r="35"
        stroke="rgb(0 0 0 / 0.2)" // black with opacity
        fill="transparent"
        strokeWidth={strokeWidth}
        variants={fadeIn}
      />
      {/* Spinning arc */}
      <motion.circle
        cx="50"
        cy="50"
        r="35"
        stroke="rgb(0 0 0)" // black
        fill="transparent"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeDasharray="60 160"
        variants={fadeIn}
        animate={{
          rotate: 360,
        }}
        transition={{
          rotate: {
            duration: 1.5,
            ease: "linear",
            repeat: Number.POSITIVE_INFINITY,
          },
        }}
        style={{
          transformOrigin: "50px 50px",
        }}
      />
    </motion.svg>
  );
}
